import memoize from 'memoize-one';

function root(state) {
    return state.data.identities;
}

export const identity = (state, identityId) => root(state).byId[identityId];

export const loading = (state, identityId) => {
    const i = identity(state, identityId);
    return i && i.loading;
}

export const loadingDetailedIdentity = (state, identityId) => {
    return loading(state, identityId);
}

export const fetchInProgress = state => root(state).fetchInProgress;
export const errorMessage = state => root(state).errorMessage;

const _namedIdentities = memoize(
    function _namedIdentities(managedIds, byId) {
        return managedIds.map(it => byId[it])
            .filter(it => it && it.name)
            .sort((a,b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1);
    }
);
export const managedIdentitiesNamed = state => _namedIdentities(root(state).managedIds, root(state).byId);

const _unnamedIdentities = memoize(
    function _unnamedIdentities(managedIds, byId) {
        return managedIds.map(it => byId[it]).filter(it => it && !it.name);
    }
);
export const managedIdentitiesUnnamed = state => _unnamedIdentities(root(state).managedIds, root(state).byId);

export const nameOptions = state => _namedIdentities(root(state).managedIds, root(state).byId)
    .map(({ name, profileImageUrl, identityId }) => ({
        label: name,
        value: name,
        profileImageUrl,
        identityId,
    }));
